<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :ripple="false" icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item @click="$emit('showAnnouncement', announcementId)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-eye </v-icon>
        <span class="body-2">{{ $t('announcement.actions.details') }}</span>
      </v-list-item>

      <v-list-item @click="$emit('duplicateAnnouncement', announcementId)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-content-duplicate </v-icon>
        <span class="body-2">{{ $t('announcement.actions.duplicate') }}</span>
      </v-list-item>

      <v-list-item @click="$emit('confirmDeleteAnnouncement', announcementId)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-delete-outline </v-icon>
        <span class="body-2">{{ $t('announcement.actions.delete') }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'AnnouncementListRowMenu',

  props: {
    announcementId: {
      type: String,
      required: true,
    },
  },
}
</script>
